import { Action } from '../Permission.action.enum';
import { PermissionModule } from '../Permission.module.enum';
import { BindSubmodule } from './Bind.submodule.enum';

enum BindPermissionsV1 {
  BIND_READ = PermissionModule.BIND + BindSubmodule.BIND + Action.READ,
}

export { BindPermissionsV1 };
